import React, { Component } from "react";
import ReactApexChart from "react-apexcharts";

class ProgressChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      series: [
        {
          name: "English",
          data: [44, 55, 57, 56, 61, 58, 63, 60, 66],
        },
        {
          name: "Math",
          data: [76, 85, 101, 98, 87, 105, 91, 114, 94],
        },
        {
          name: "Science",
          data: [35, 41, 36, 26, 45, 48, 52, 53, 41],
        },
      ],
      options: {
        colors: ["#FDC419", "#87C14A", "#954C9E"],
        grid: {
          row: {
            colors: ["#fff", "#fff", "#fff"],
          },
          column: {
            colors: ["#fff", "#fff", "#fff"],
          },
        },
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: [
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
          ],
        },
        yaxis: {},
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return "$ " + val + " thousands";
            },
          },
        },
      },
    };
  }

  render() {
    return (
      <div id="chart">
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="bar"
          height={350}
        />
      </div>
    );
  }
}

export default ProgressChart;
